<template>
  <header class="text-center">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <div class="nav-flex">
          <div
            class="text-left d-flex"
            style="color: black"
          >
            <div class="menu">
              <div @click="openNav()">
                <div class="mr-4">
                  <div class="bar1"></div>
                  <div class="bar2"></div>
                  <div class="bar3"></div>
                </div>
              </div>
            </div>
            <div>
              <span style="font-weight: 600">
                {{ $store.state.currentFullName }} </span><br />
              <small
                class="text-success"
                v-if="$store.state.currentRole == 'ADMIN'"
              >Admin</small>
              <small
                class="text-success"
                v-else
              > Role - {{$store.state.currentRole}}</small>
            </div>
          </div>

          <div class="
              nav-list-two
              d-flex
              align-items-center
              justify-content-center
            ">
            <div class="theProfile">
              <div style="width: 40px; height: 40px; border-radius: 50%">
                <div style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #233A2E;
                    color: white;
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                    border-radius: 100%;
                  ">
                  <img
                    style="border-radius:100%; width:40px; height: 40px; border: 2px solid #944597;"
                    :src="$store.state.currentUserPhoto"
                  >
                  <!-- <strong>{{
                    getInitials($store.state.currentFullName)
                  }}</strong> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class="">
      <el-dialog
        title="Outer Dialog"
        :visible.sync="outerVisible"
        center
      >
        <div
          slot="footer"
          class="dialog-footer"
        ></div>
      </el-dialog>
    </div>

    <el-drawer
      title="I am the title"
      :visible.sync="sidebarDrawer"
      direction="ltr"
      size="70%"
      :with-header="false"
    >
      <div class="sidebar">
        <div style="cursor: pointer">
          <div style="
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
            ">
            <img
              :src="$store.state.logoImageUrl"
              style="height: 8em; border-radius: 10px;"
              alt=""
              class="img-fluid"
            />
          </div>
        </div>
        <div class="side-link">
          <ul>
            <li
              class="text-white"
              @click="closeNav()"
            >
              {{ $store.state.currentFullName }}
            </li>
            <!-- <li
              class="text-white"
              @click="closeNav()"
            >
              <router-link to="/quotations">
                <i class="fas fa-book"></i> Requested Safari Quotes
              </router-link>
            </li> -->
            <li
              class="text-white"
              @click="closeNav()"
            >
              <router-link to="/sliders">
                <i class="fas fa-book"></i> Sliderss
              </router-link>
            </li>
            <li
              class="text-white"
              @click="closeNav()"
            >
              <router-link to="/newsroom">
                <i class="fas fa-star"></i> Newsroom
              </router-link>
            </li>
            <!-- <li
              class="text-white"
              @click="closeNav()"
            >
              <router-link to="/countries">
                <i class="fas fa-book"></i> Gallery
              </router-link>
            </li> -->
        
            <!-- <li
              class="text-white"
              @click="closeNav()"
            >
              <router-link to="/experiences">
                <i class="fas fa-star"></i> Members
              </router-link>
            </li> -->
            <!-- <li
              class="text-white"
              @click="closeNav()"
            >
              <router-link to="/experiences">
                <i class="fas fa-star"></i> Excom members
              </router-link>
            </li> -->
            <li
              class="text-white"
              @click="closeNav()"
              v-if="$store.state.currentRole == 'ADMIN'"
            >
              <router-link to="/users">
                <i class="fas fa-users"></i> Users
              </router-link>
            </li>
            <li
              class="text-white"
              @click="logout"
            >
              <i class="fas fa-arrow-left"></i> Logout
            </li>
          </ul>
        </div>
      </div>
    </el-drawer>
  </header>
</template>

<script>
// import SidebarComponent from './sidebar-component.vue';
import jwt_decode from "jwt-decode";
export default {
  // components: {SidebarComponent},
  data() {
    return {
      drawer: false,
      sidebarDrawer: false,
      outerVisible: false,
      innerVisible: false,
    };
  },

  computed: {
    getInitials() {
      return (nameString) => {
        //  format(parseISO(dateString), "do MMMM yyyy");
        var names = nameString.split(" "),
          initials = names[0].substring(0, 1).toUpperCase();
        if (names.length > 1) {
          initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
      };
    },
  },

  mounted() {
    this.setCurrentUser();
  },

  methods: {
    openNav() {
      this.sidebarDrawer = true;
    },

    closeNav() {
      this.sidebarDrawer = false;
    },

    setCurrentUser() {
      let userToken = JSON.parse(localStorage.getItem("user"));
      let decoded = jwt_decode(userToken);
      this.$store.commit("setCurrentUsername", decoded.data.username);
      this.$store.commit("setCurrentFullName", decoded.data.fullname);
      this.$store.commit("setCurrentRole", decoded.data.role);
      this.$store.commit("setCurrentPhoto", decoded.data.image);
    },
    logout() {
      // remove user from local storage to log user out currentUserPhoto
      localStorage.removeItem("user");
      this.sidebarDrawer = false;
      location.reload(true);
    },
  },
};
</script>

<style scoped>
nav {
  background-color: #f5f7fa;
  color: #fbf2e1;
  padding-top: 10px;
  padding-bottom: 10px;
}
nav a {
  color: #fbf2e1;
  text-decoration: none;
}
a .active {
  border-bottom: 1px solid #d96b12;
  color: #d9ae3b;
  font-weight: 600;
}

a:hover span {
  border-bottom: 1px solid #d96b12;
  transition: 0.5s;
}

.side-link {
  color: var(--el-app-primary);
  padding: 10px 30px;
  cursor: pointer;
  transition: 0.5s;
}

.nav-flex {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-one {
  cursor: pointer;
  transition: 0.5s;
}

.nav-flex .nav-list-two {
  list-style: none;
  height: 100%;
  padding: 0px;
}

.nav-flex span {
  cursor: pointer;
  transition: 0.5s;
}

.nav-flex span:hover {
  color: #d96b12;
  transition: 0.5s;
}

/* .brand-name {
  width: 100px !important;
  padding: 0px;
  margin: 50px 0px 0px 0px !important;
  margin: 0px auto;
}

.brand-name img {
  width: 100px;
  padding: 0px;
  margin: 0px;
} */

.bookBtn {
  border: 1px solid #fbf2e1;
  border-radius: 0px;
  background-color: transparent;
  color: #fbf2e1;
  transition: 0.5s;
}

.bookBtn:hover {
  color: #d96b12;
  transition: 0.5s;
}

.menu {
  display: none;
}

.bar1,
.bar2,
.bar3 {
  width: 25px;
  height: 2px;
  background-color: black;
  margin: 5px 0;
  border-radius: 3px;
  transition: 0.4s;
}

.change .bar1 {
  -webkit-transform: rotate(-45deg) translate(-9px, 6px);
  transform: rotate(-45deg) translate(-9px, 6px);
}

.change .bar2 {
  opacity: 0;
}

.change .bar3 {
  -webkit-transform: rotate(45deg) translate(-8px, -8px);
  transform: rotate(45deg) translate(-8px, -8px);
}

.showDesktopOnly {
  display: block;
}
.showMobileOnly {
  display: none;
}

.sidebar {
  background-color: #233a2e;
  height: 100%;
  padding: 50px 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
  text-align: left;
}

.sidebar ul li {
  border-bottom: 1px solid #233a2e;
  padding-top: 30px;
}

.sidebar ul li a {
  color: #fbf0e0;
}

.sidebar ul li a:hover {
  color: #fdfdfd;
}

/*##Device = Tablets, Ipads (portrait)##Screen = B/w 768px to 1024px*/
@media (min-width: 768px) and (max-width: 1024px) {
  .menu {
    display: block;
  }
  .list-one {
    display: none;
  }
  .showDesktopOnly {
    display: none;
  }
  .showMobileOnly {
    display: block;
  }
}

/*##Device = Tablets, Ipads (landscape)##Screen = B/w 768px to 1024px*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .menu {
    display: block;
  }
  .showDesktopOnly {
    display: none;
  }
  .showMobileOnly {
    display: block;
  }
  .list-one {
    display: none;
  }
}

/*##Device = Low Resolution Tablets, Mobiles (Landscape) ##Screen = B/w 481px to 767px*/
@media (min-width: 481px) and (max-width: 767px) {
  .menu {
    display: block;
  }
  .showDesktopOnly {
    display: none;
  }
  .showMobileOnly {
    display: block;
  }
  .list-one {
    display: none;
  }
}

/*##Device = Most of the Smartphones Mobiles (Portrait) ##Screen = B/w 320px to 479px*/
@media (min-width: 320px) and (max-width: 480px) {
  .menu {
    display: block;
  }
  .list-one {
    display: none;
  }
  .showDesktopOnly {
    display: none;
  }
  .showMobileOnly {
    display: block;
  }
}
</style>

<style>
el-drawer {
  background-color: red;
}
.v-modal {
  z-index: 0 !important;
}
</style>